module.exports = __webpack_public_path__ + "img/exam-camera.3673fcac.png";